import { action } from 'typesafe-actions';

import ActionTypes from './constants';

export const showInactiveSamplePointErrorModal = () =>
  action(ActionTypes.LAYOUT_SHOW_INACTIVE_SAMPLE_POINT_ERROR_MODAL);

export const hideInactiveSamplePointErrorModal = () =>
  action(ActionTypes.LAYOUT_HIDE_INACTIVE_SAMPLE_POINT_ERROR_MODAL);

export const hideNavigation = () => action(ActionTypes.LAYOUT_HIDE_NAVIGATION);
export const showNavigation = () => action(ActionTypes.LAYOUT_SHOW_NAVIGATION);